(function($) {

  function leadershipSlider() {
    var $slider = $('.about-leadership .leader-container.is-slider');

    $slider.slick({
      centerMode: true,
      slidesToShow: 6,
      slidesToScroll: 5,
      dots: true,
      arrows: false,
      autoplay: false,
      centerMode: false,
      infinite: false,
      responsive: [
        {
          breakpoint: 1450,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
          }
        },
      ]
    });


    function arrowNav() {
      var $prevArrow  = $(".about-leadership .arrow-nav .prev");
      var $nextArrow  = $(".about-leadership .arrow-nav .next");

      $prevArrow.click(function(){
        $slider.slick('slickPrev');
      })

      $nextArrow.click(function(){
        $slider.slick('slickNext');
      })
    }
    arrowNav();
  }
  leadershipSlider();


  function detectDotLength() {
    if ( $('.about-leadership .slick-dots li').length <= 1) {
      $('.about-leadership .arrow-nav').addClass('is-hidden');
      $('.about-leadership .slick-dots').addClass('is-hidden');
    } else {
      $('.about-leadership .arrow-nav').removeClass('is-hidden');
      $('.about-leadership .slick-dots').removeClass('is-hidden');
    }
  }
  detectDotLength();

  $(window).resize(function(){
    detectDotLength();
  });




  function numberAnimation() {
    var $aboutNumbers = $('.about-numbers');
    var $numberCol = $('.about-numbers .col');

    function animateNumber() {
      $numberCol.each(function() {
        var $this = $(this),
            endVal = $this.find('span').text();

        $({ Counter: 0 }).animate({ Counter: endVal }, {
          duration: 750,
          easing: 'swing',
          step: function() {
            $this.find('span').text(Math.ceil(this.Counter));
          }
        });
      });
    }

    if ($aboutNumbers.length) {
      var waypointContact = new Waypoint({
        element: $aboutNumbers,
        handler: function(direction) {
          if (direction === 'down') {
            $aboutNumbers.addClass('in-view');
            animateNumber();
          }
        },
        offset: '75%'
      });
    }
  }
  numberAnimation();





  function bioModal() {
    var $modal = $('.modal--bio');
    var $modalCloseBtn = $('.modal--bio .close-btn');
    var $modalHeadshot = $modal.find('.img-box figure');
    var $modalLeader = $modal.find('.title-col h1');
    var $modalPosition = $modal.find('.title-col p');
    var $modalBio = $modal.find('.content-col p');
    var $modalInnerWrap = $modal.find('.inner-wrap');

    var $leaderElem = $('.about-leadership .content-box');
    var froze = 'is-froze';


    $leaderElem.click(function(){
      var $thisElem = $(this);
      var $thisImgURL = $(this).attr('data-hero');
      var $thisHeading  = $(this).find('h4').text();
      var $thisPosition = $(this).find('p:not(.link)').text();
      var $thisBio      = $(this).attr('data-bio');

      $modal.addClass('is-active');

      $modalHeadshot.css('background-image', 'url(' + $thisImgURL + ')');
      $modalLeader.text($thisHeading);
      $modalPosition.text($thisPosition);
      $modalBio.text($thisBio);
      $('body').toggleClass(froze);
    });

    $modalCloseBtn.click(function(){
      $modal.removeClass('is-active');
      $('body').removeClass(froze);
    });


    $modalInnerWrap.click(function(e){
      e.stopPropagation();
    })

    $modal.click(function(){
      $modal.removeClass('is-active');
      $('body').removeClass(froze);
    })



    var $docEl = $('html, body'),
    		$wrap = $('.max-container'),
    		scrollTop;

    $.lockBody = function() {
      if(window.pageYOffset) {
        scrollTop = window.pageYOffset;

        $wrap.css({
          top: - (scrollTop)
        });
      }

      $docEl.css({
        height: "100%",
        overflow: "hidden"
      });
    }

    $.unlockBody = function() {
      $docEl.css({
        height: "",
        overflow: ""
      });

      $wrap.css({
        top: ''
      });

      window.scrollTo(0, scrollTop);
      window.setTimeout(function () {
        scrollTop = null;
      }, 0);

    }




  }
  bioModal();


  if($('.modal--bio .inner-wrap').length) {
    var ps = new PerfectScrollbar('.modal--bio .inner-wrap');
  }









}(jQuery));



// WEBPACK FOOTER //
// ./assets/js/about.js